import React from "react";
import { Sidebar } from "primereact/sidebar";

const CustomSidebar = ({
  visible,
  onHide,
  title = "Sidebar Title",
  children,
  width = "500px",
  position = "right",
}) => {
  return (
    <Sidebar
      visible={visible}
      onHide={onHide}
      position={position}
      style={{ width }}
      showCloseIcon={false}
      
    >
      
      <div className="flex items-center justify-between bg-slate-100 rounded-[10px] px-4 py-3 mb-4">
        <span className="text-customGreen font-semibold text-lg">{title}</span>

        <button
          onClick={onHide}
          className="text-red-600 bg-white px-2 focus:outline-none rounded-full p-1"
          aria-label="Close sidebar"
        >
          <svg
            className="w-5 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="pt-2">{children}</div>
    </Sidebar>
  );
};

export default CustomSidebar;
